<div class="container-base">
  <mat-card>
    <mat-card-title>
      <img src="{{logoSrc}}" alt="logo" class="logo" />
    </mat-card-title>
    <mat-card-subtitle>{{ 'labels.resetPassword' | translate }}</mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field class="full-width-input">
          <input matInput class="lowercase" placeholder="{{ 'labels.email' | translate }}" formControlName="username" required autofocus />
          <mat-error>{{ 'errors.required.email' | translate }}</mat-error>
        </mat-form-field>
        <button mat-raised-button [disabled]="!form.valid || sent" color="primary">{{ 'buttons.requestNewPassword' | translate }}</button>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="password-sent" *ngIf="sent">
        {{ 'messages.newPasswordSent' | translate }}
      </div>
    </mat-card-footer>
  </mat-card>
</div>